import IconWasteMini from '~/components/icon/IconWasteMini.vue';
import IconWasteSmall from '~/components/icon/IconWasteSmall.vue';
import IconWasteMedium from '~/components/icon/IconWasteMedium.vue';
import IconWasteLarge from '~/components/icon/IconWasteLarge.vue';
import IconWasteXlarge from '~/components/icon/IconWasteXlarge.vue';
import IconWasteMassive from '~/components/icon/IconWasteMassive.vue';

export default {
    computed: {
        vanSizes() {
            return [
                {
                    id: 1,
                    icon: IconWasteMini,
                    name: 'Mini',
                    slug: 'mini',
                    specs: ['5-10 black bags', '2 yd³', '~75kg'],
                },
                {
                    id: 1,
                    icon: IconWasteSmall,
                    name: 'Small',
                    slug: 'small',
                    specs: ['10-15 black bags', '2 yd³', '~200kg'],
                },
                {
                    id: 1,
                    icon: IconWasteMedium,
                    name: 'Medium',
                    slug: '1_4',
                    specs: ['25-30 black bags', '4 yd³', '~400kg'],
                },
                {
                    id: 1,
                    icon: IconWasteLarge,
                    name: 'Large',
                    slug: '1_2',
                    specs: ['45-50 black bags', '7 yd³', '~700kg'],
                },
                {
                    id: 1,
                    icon: IconWasteXlarge,
                    name: 'XL',
                    slug: '3_4',
                    specs: ['60-65 black bags', '10 yd³', '~1000kg'],
                    horizontal: !this.isMobile,
                },
                {
                    id: 1,
                    icon: IconWasteMassive,
                    name: 'XXL',
                    slug: 'full',
                    specs: ['14 yd³', '75-90 black bags', '~1400kg'],
                    horizontal: !this.isMobile,
                },
            ];
        },
    },
};
